import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../config/firebase-config';
import { notifyPermissionDenied } from '../handleCallableError';

export const getDealershipEfficiencyComparison = async (groupId, startDate = null, endDate = null, relatedDealershipIds = []) => {
  if (!groupId) {
    console.error('Group ID no proporcionado');
    return [];
  }

  try {
    const getComparisonFn = httpsCallable(functions, 'getDealershipEfficiencyComparisonV2');
    const result = await getComparisonFn({
      groupId,
      requestedApp: 'group_web',
      startDate: startDate instanceof Date ? startDate.getTime() : null,
      endDate: endDate instanceof Date ? endDate.getTime() : null,
      relatedDealershipIds,
    });

    if (Array.isArray(result.data)) {
      return result.data;
    }
    if (result.data && result.data.success === 'yes') {
      return result.data.data || [];
    }
    return [];
  } catch (error) {
    console.error('Error obteniendo comparación de eficiencia:', error);
    notifyPermissionDenied(error);
    return [];
  }
};
